import { countryList } from '../constants/countries';

export const getCountryNameByTwoDigits = (digitCode: string) => {
  return countryList.find((el) => el.two_digit_code === digitCode);
};
